import createFocusTrap from 'focus-trap';
import { getLocale, localizeLink } from '../../util/locale';
import { trackInteraction } from '../../analytics';
import { getClosestMarket } from './main';

const locale = getLocale();
const SEGMENTATION_V1_SUBMIT_BUTTON_ID = 'segmentation-submit__button';
const SEGMENTATION_V1_START_BUTTON_ID = 'segmentation-start__button';

const segmentorV1FormButton = document.getElementById(SEGMENTATION_V1_SUBMIT_BUTTON_ID);
const segmentorV1StartButton = document.getElementById(SEGMENTATION_V1_START_BUTTON_ID);
const segmentorV1CloseButton = document.getElementById('segmentation-hero__button-close');
const locationsDropdown = document.getElementById('locations-dropdown');
const companySizeRadios = document.querySelectorAll('input[name = "company-size"]');

let segmentorFormOpen = false;
let segmentorOverlayFocusTrap;

const _toggleSegmentorV1Form = evt => {
  const { body } = document;
  const overlay = document.getElementById('segmentation-overlay');

  if (!segmentorFormOpen) {
    evt.preventDefault();
    overlay.classList.add('open');
    body.classList.add('js-lock-scroll');
    overlay.setAttribute('aria-hidden', 'false');
    document.addEventListener('keydown', handleEscape);
    segmentorOverlayFocusTrap.activate();
  } else {
    body.classList.remove('js-lock-scroll');
    overlay.classList.remove('open');
    overlay.setAttribute('aria-hidden', 'true');
    segmentorOverlayFocusTrap.deactivate();
    document.removeEventListener('keydown', handleEscape);
  }
  segmentorFormOpen = !segmentorFormOpen;
};

const _getFormRedirectPath = () => {
  const companySizeRadioSelection = document.querySelector('input[name = "company-size"]:checked');
  const selectedMarketPath = locationsDropdown.options[locationsDropdown.selectedIndex].getAttribute(
    'data-market-path'
  );
  const selectedSegmentPath =
    companySizeRadioSelection && companySizeRadioSelection.getAttribute('data-segmentor-path');

  const to = selectedSegmentPath || selectedMarketPath;
  const localizedPath = localizeLink({ locale, to });
  return localizedPath;
};

const _handleSubmitForSegmentorV1 = event => {
  event.preventDefault();

  const submitButton = document.getElementById(SEGMENTATION_V1_SUBMIT_BUTTON_ID);

  try {
    submitButton.disabled = true;
    window.location = _getFormRedirectPath();
  } catch (error) {
    submitButton.disabled = false;
  }
};

export const setupOverlaySegmentorForm = () => {
  const startSegmentationBtn = document.getElementById(SEGMENTATION_V1_START_BUTTON_ID);
  segmentorOverlayFocusTrap = createFocusTrap('#segmentation-overlay', {
    initialFocus: '#initial-focus-catcher'
  });
  if (startSegmentationBtn) {
    startSegmentationBtn.addEventListener('click', _toggleSegmentorV1Form);
  }
  segmentorV1CloseButton.addEventListener('click', _toggleSegmentorV1Form);
  segmentorV1FormButton.addEventListener('click', _handleSubmitForSegmentorV1);
};

export const setupSegmentorFormAnalyticsTracking = async () => {
  const geoLocatedMarket = await getClosestMarket();

  if (locationsDropdown) {
    locationsDropdown.addEventListener('click', () => {
      trackInteraction({
        label: 'segmentor form interaction market'
      });
    });
  }

  if (segmentorV1StartButton) {
    segmentorV1StartButton.addEventListener('click', () => {
      const selectedMarketName = locationsDropdown.options[locationsDropdown.selectedIndex].text;
      trackInteraction({
        label: 'open segmentation overlay',
        marketName: selectedMarketName,
        marketID: locationsDropdown.value,
        isGeolocatedMarket: geoLocatedMarket.name === selectedMarketName
      });
    });
  }

  if (segmentorV1CloseButton) {
    segmentorV1CloseButton.addEventListener('click', () => {
      trackInteraction({
        label: 'close segmentation overlay'
      });
    });
  }

  for (let i = 0; i < companySizeRadios.length; i++) {
    const radioEl = companySizeRadios[i];
    radioEl.addEventListener('click', () => {
      trackInteraction({
        label: 'segmentor form interaction company size'
      });
    });
  }

  if (segmentorV1FormButton) {
    segmentorV1FormButton.addEventListener('click', () => {
      const selectedMarketName = locationsDropdown.options[locationsDropdown.selectedIndex].text;
      const companySizeRadioSelection = document.querySelector('input[name = "company-size"]:checked');
      const companySizeRadioSelectionValue = companySizeRadioSelection && companySizeRadioSelection.value;

      trackInteraction({
        label: 'segmentor form submitted',
        locale,
        marketName: selectedMarketName,
        marketID: locationsDropdown.value,
        companySize: companySizeRadioSelectionValue,
        isGeolocatedMarket: geoLocatedMarket.name === selectedMarketName
      });
    });
  }
};

function handleEscape(event) {
  const { key, keyCode } = event;

  if (key === 'Escape' || keyCode === 27) {
    _toggleSegmentorV1Form(event);
  }
}
